module.exports = __webpack_public_path__ + "static/media/ic-file-search.5ea6175f.svg";